import { gql } from '@/core/shared/api';
import { closingStation } from './fragments';
import moment from 'moment-timezone';

export const getStationClosings = async ({ dispatch, commit, rootGetters }, { locationId, stationId = '', startTime = '', endTime = '' }) => {
  commit('setLoading', true);
  commit('stationTemporaryClosing/set', {
    path: 'isFetchingClosings',
    value: true,
  });

  let query = `{
    StationTemporaryClosings(
      location: { id: "${locationId}"}`;

  if (stationId !== '') {
    query += `,
    station: { id: "${stationId}"}`;
  }

  if (startTime !== '') {
    const startTimeFormatted = moment(startTime).set({
      hour: 0,
      minute: 0,
      second: 0,
    }).format();

    query += `,
    startTime: "${startTimeFormatted}"`;
  }

  if (endTime !== '') {
    const endTimeFormatted = moment(endTime).set({
      hour: 0,
      minute: 0,
      second: 0,
    }).format();

    query += `,
    endTime: "${endTimeFormatted}"`;
  }

  query += `
  ) {
    ${closingStation}
  }
}`;

  try {
    const { StationTemporaryClosings } = await gql.request(query);

    // add the closings to the cache
    dispatch('insertEntities', {
      name: 'StationTemporaryClosing',
      payload: StationTemporaryClosings,
    });

    // remove the ones we don't have anymore
    const closingIdsFromApi = StationTemporaryClosings.map(closing => closing.id);
    rootGetters['entities/StationTemporaryClosing/all']().forEach(closing => {
      if (!closingIdsFromApi.includes(closing.id)) {
        dispatch('removeEntities', {
          name: 'StationTemporaryClosing',
          payload: closing,
        });
      }
    });

    return StationTemporaryClosings;
  } finally {
    commit('setLoading', false);
    commit('stationTemporaryClosing/set', {
      path: 'isFetchingClosings',
      value: false,
    });
  }
};

export const closeStation = async ({ commit, dispatch }, closure) => {
  commit('setLoading', true);
  const mutation = `mutation closeStationTemporary($closure: StationTemporaryClosingInput) {
    closeStationTemporary(stationTemporaryClosing: $closure) {
      ${closingStation}
    }
  }`;

  try {
    const { StationTemporaryClosings } = await gql.request(mutation, { closure });

    dispatch('insertEntities', {
      name: 'StationTemporaryClosing',
      payload: StationTemporaryClosings,
    });

    return StationTemporaryClosings;
  } finally {
    commit('setLoading', false);
  }
};

export const reopenStation = async ({ commit, dispatch }, closure) => {
  commit('setLoading', true);
  const mutation = `mutation closeStationTemporary($closure: StationTemporaryClosingInput) {
    cancelCloseStationTemporary(stationTemporaryClosing: $closure) {
      id
    }
  }`;

  try {
    const { stationgId } = await gql.request(mutation, { closure });

    dispatch('removeEntities', {
      name: 'StationTemporaryClosing',
      payload: closure,
    });

    return stationgId;
  } finally {
    commit('setLoading', false);
  }
};
